import React from 'react';
import AdSenseAd from './AdSenseAd';
import AD_CONFIG from './AdConfig';

const InFeedAd = () => {
  // Don't render if in-feed ads are disabled
  if (!AD_CONFIG.enabled || !AD_CONFIG.placements.inFeed.enabled) {
    return null;
  }

  const { slot, format, layoutKey } = AD_CONFIG.placements.inFeed;

  return (
    <div className="in-feed-ad">
      <AdSenseAd 
        adSlot={slot}
        adFormat={format}
        adLayoutKey={layoutKey}
        style={{ display: 'block' }}
      />
    </div>
  );
};

export default InFeedAd;
